module.exports = __webpack_public_path__ + "static/media/photo-7.0f030854.avif";